import React from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
//import Layout from '../components/layout' 
import Carousel, { slidesToShowPlugin } from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import {
    FaSass,
    FaHtml5,
    FaReact,
    FaMobileAlt,
    FaRocket,
    FaLink,
    FaExternalLinkAlt
} from 'react-icons/fa';
import { motion } from "framer-motion";
import ContextConsumer from "../components/context"
import ContextUpdater from "../components/context_updater"
import Gallery from '@browniebroke/gatsby-image-gallery'
import '@browniebroke/gatsby-image-gallery/dist/style.css'

// Decode HTML from server
const renderHTML = (rawHTML) => {
    return React.createElement(
        "span",
        { dangerouslySetInnerHTML: { __html: rawHTML } }
    );
}

// Render Images in columns
const renderImagesSection = ((images, section) => {
    return (
        images.map(image => {
            if (image.localImage.ext.toLowerCase() == ".gif"){
                return (
                  <div key={image.pk} className="columns">
                      <div className="column column-image">
                          <img className={ image.shadow ? "image-shadow" : ""} src={image.localImage.publicURL} />
                      </div>
                  </div>
                )
            } else {
              if (section.layout == "text_image"){
                return (
                    <div key={image.pk} className="columns">
                        <motion.div
                          className="column column-image"
                          whileHover={{ scale: 1.1, zIndex: 101 }}
                          whileTap={{ scale: 1.75, zIndex: 102 }}
                          transition={{ duration: 0.3 }}
                        >
                            <Img className={ (image.shadow ? "image-shadow" : "") + (image.rounded ? " image-rounded" : "") } fluid={image.localImage.childImageSharp.fluid} />
                        </motion.div>
                    </div>
                )
              } else {
                return (
                    <div key={image.pk} className="columns">
                        <motion.div
                          className="column column-image"
                        >
                            <Img className={ (image.shadow ? "image-shadow" : "") + (image.rounded ? " image-rounded" : "") } fluid={image.localImage.childImageSharp.fluid} />
                        </motion.div>
                    </div>
                 )
              }
            }
        })
    )
})

const renderImageSections = (section => {
    if (section.worksectionimage_set && section.worksectionimage_set.length > 0) {
      return renderImagesSection(section.worksectionimage_set, section)
    }
})

// Render images as plain img tags
const renderPlainImages = (images => {
    return (
        images.map(image => {
            return (
                <img style={{height: '80vh', width: 'auto'}} key={image.pk} src={image.localImage.childImageSharp.fluid.src} />
            )
        })
    )
})

const renderImagesPlain = (section => {
    if (section.worksectionimage_set && section.worksectionimage_set.length > 0) {
      return renderPlainImages(section.worksectionimage_set)
    }
})

///////////////////
// Text Section //
/////////////////
const render_section_text = (section => {
    return (
            <div className="columns">
                <div className="column">
                      <div className="content">
                        {renderHTML(section.text)}
                      </div>
                </div>
            </div>
    )
})

const render_section_text_image = (section => {
    if (section.align_vertical = "m"){
        var valign = "columns is-vcentered";
    } else {
        var valign = "columns";
    }
    if (section.align == 'l'){
      return (
              <div className={valign}>
                  <div className="column">
                      <div className="content">
                        {renderHTML(section.text)}
                      </div>
                  </div>
                  <div className="column">
                      {renderImageSections(section)}
                  </div>
              </div>
      )
    } else {
      return (
              <div className={valign}>
                  <div className="column">
                      {renderImageSections(section)}
                  </div>
                  <div className="column">
                      <div className="content">
                        {renderHTML(section.text)}
                      </div>
                  </div>
              </div>
      )
    }
})

const render_section_image = (section => {
      return (
        <React.Fragment>
            {renderImageSections(section)}
        </React.Fragment>
      )
})

const render_section_image_gallery = (section => {
	  //const images = section.worksectionimage_set.map(({ image }) => image.localImage.childImageSharp)
	  const images = section.worksectionimage_set.map(({ localImage, title }) => ({
		  ...localImage.childImageSharp,
		  caption: title, 
		  className: "galleryThumb"
		})
	  )
	  return <div className="gallery"><Gallery images={images} /></div>
      return (
        <div>
        <Carousel
          offset={50}
          plugins={[
            'centered',
            'infinite',
            'fastSwipe',
            //'arrows',
            {
              resolve: slidesToShowPlugin,
              options: {
               numberOfSlides: 3
              }
            },
          ]}
          breakpoints={{
              767: {
                plugins: [
                 {
                   resolve: slidesToShowPlugin,
                   options: {
                    numberOfSlides: 1
                   }
                 },
               ]
              },
              1024: {
                plugins: [
                 {
                   resolve: slidesToShowPlugin,
                   options: {
                    numberOfSlides: 2
                   }
                 },
               ]
              }
            }}
        >
            {renderImagesPlain(section)}
        </Carousel>
        </div>
      )
})

const render_section_2_1_1 = (section => {
    if (section.align == 'l'){
      return (
              <div className="columns is-8">
                  <div className="column is-two-thirds">
                        <Img fluid={section.worksectionimage_set[0].localImage.childImageSharp.fluid} />
                  </div>
                  <div className="column is-one-third">
                      <div className="columns is-8">
                        <div className="column">
                          <Img fluid={section.worksectionimage_set[1].localImage.childImageSharp.fluid} />
                        </div>
                      </div>
                      <div className="columns is-8">
                        <div className="column">
                            <Img fluid={section.worksectionimage_set[2].localImage.childImageSharp.fluid} />
                        </div>
                      </div>
                  </div>
              </div>
      )
    } else {
      return (
              <div className="columns is-8">
                  <div className="column is-one-third">
                      <div className="columns is-8">
                        <div className="column">
                          <Img fluid={section.worksectionimage_set[1].localImage.childImageSharp.fluid} />
                        </div>
                      </div>
                      <div className="columns is-8">
                        <div className="column">
                            <Img fluid={section.worksectionimage_set[2].localImage.childImageSharp.fluid} />
                        </div>
                      </div>
                  </div>
                  <div className="column is-two-thirds">
                        <Img fluid={section.worksectionimage_set[0].localImage.childImageSharp.fluid} />
                  </div>
              </div>
      )
    }
})

//////////////
// Helpers //
////////////
const render_debug = (section => {
    return (
        <React.Fragment>
          <p>layout: {section.layout}</p>
          <p>align: {section.align}</p>
          <p>wide: {section.wide ? <span>True</span> : <span>False</span>}</p>
          <p>full: {section.full ? <span>True</span> : <span>False</span>}</p>
          <p>sorting: {section.sorting}</p>
        </React.Fragment>
    )
})

const render_section = (section => {
    if (section.full){
        return (
            <div className="full_section">
            { render_section_contents(section) }
            </div>
        )
    } else if (section.wide){
        return (
            <div className="wide_section container">
              <div className="columns">
                <div className="column"></div>
                <div className="column is-four-fifths">
                    { render_section_contents(section) }
                </div>
                <div className="column"></div>
              </div>
            </div>
        )
    } else {
        return (
            <div className="normal_section container">
              <div className="columns">
                <div className="column is-half is-offset-one-quarter">
                    { render_section_contents(section) }
                </div>
              </div>
            </div>
        )
    }
})

const render_section_contents = (section => {
    return (
        <React.Fragment>
            { section.layout == "text" ? render_section_text(section) : null}
            { section.layout == "text_image" ? render_section_text_image(section) : null}
            { section.layout == "image" ? render_section_image(section) : null}
            { section.layout == "image_2_1_1" ? render_section_2_1_1(section) : null}
            { section.layout == "image_gallery" ? render_section_image_gallery(section) : null}
            {/**renderImageSections(section)**/}
        </React.Fragment>
    )
})

const PortfolioTemplate = ({ data, pageContext} ) => {
    const doc = data.allRestApiWork.edges[0].node
    //const debug = true // Show or hise debug info
    const debug = false // Show or hise debug info
    console.log(doc);

    // Link
    if (doc.link){
      var link = <p className="link">
            <a href={doc.link}>
                Visit site <FaExternalLinkAlt style={{verticalAlign: "middle", fontSize: "1rem"}} />
            </a>
        </p>
    } else {
      var link = null;
    }

    if (doc.localHeroImage){
        if (doc.hero_align == "c"){
            var header = <div className="container">
            <div className="work-header">
                <Img
                    style={{ maxHeight: "50vh", width: "auto" }}
                    fluid={doc.localHeroImage.childImageSharp.fluid}
                    imgStyle={{
                        objectFit: 'contain',
                        objectPosition: 'center center',
                    }}
                />
                <h1>{doc.title}</h1>
                {link}
                  <div className="columns">
                    <div className="column is-half is-offset-one-quarter">
                        <p className="lead">{renderHTML(doc.blurb)}</p>
                    </div>
                  </div>
              </div>
            </div>
        } else if (doc.hero_align == "l"){
            var header = <div className="container">
              <div className="work-header work-header-hero-left">
                <div className="columns is-vcentered">
                  <div className="column is-half hero-image">
                    <Img
                      style={{ maxHeight: "75vh", width: "auto" }}
                      fluid={doc.localHeroImage.childImageSharp.fluid}
                      imgStyle={{
                          objectFit: 'contain',
                          objectPosition: 'center center',
                      }}
                    />
                  </div>
                  <div className="column is-one-third-tablet hero-text">
                    <h1>{doc.title}</h1>
                    {link}
                    <p className="lead">{renderHTML(doc.blurb)}</p>
                  </div>
                </div>
              </div>
            </div>
        } else if (doc.hero_align == "r"){
            var header = <div className="container">
              <div className="work-header work-header-hero-right">
                <div className="columns">
                  <div className="column is-one-third-tablet hero-text">
                    <h1>{doc.title}</h1>
                    {link}
                    <p className="lead">{renderHTML(doc.blurb)}</p>
                  </div>
                  <div className="column is-half hero-image">
                    <Img
                      style={{ maxHeight: "75vh", width: "auto" }}
                      fluid={doc.localHeroImage.childImageSharp.fluid}
                      imgStyle={{
                          objectFit: 'contain',
                          objectPosition: 'center center',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
        }
    } else {
        var header = <div className="container">
        <div className="work-header">
            <h1>{doc.title}</h1>
              <div className="columns">
                <div className="column is-half is-offset-one-quarter">
                    <p className="lead">{renderHTML(doc.blurb)}</p>
                </div>
              </div>
          </div>
        </div>
    }


    // Next Link Footer if it exists
    if (pageContext.next){
        var next = <Link
			to={"/" + pageContext.next.slug}
			className="work-footer-link"
            //style={{
            //    backgroundImage: pageContext.next.localImage ? ('url(' + pageContext.next.localImage.childImageSharp.fluid.src + ')') : 'none',
			//}}
		>
            <span>Next </span>
            {pageContext.next.title}
        </Link>
    } else {
        var next = null;
    }

    // Prev Link Footer if it exists
    if (pageContext.prev){
        var prev = <Link to={"/" + pageContext.prev.slug} className="work-footer-link">
            <span>Previous </span>
            {pageContext.prev.title}
        </Link>
    } else {
        var prev = null;
    }


    return (
  		<ContextConsumer>
		{cdata => 
			<>
			    <ContextUpdater
					context={cdata}
					newContext={
					  {
						body_colour: doc.body_colour,
						header_text_colour: doc.header_text_colour,
						text_colour: doc.text_colour,
						header_image: doc.localHeaderImage ? doc.localHeaderImage : false
					  }
					}
				/>
				<div className="work-page">
				{header}
				  { doc.worksection_set.map((section, i) => {
					return (
						<div className="work-section" key={section.pk}>
							{ debug ? render_debug(section) : null}
							{ render_section(section) }
						</div>
					)
				  }) }
				</div>
        
				<div className="container work-footer">
					<div className="columns">
					  <div className="column">
						{prev}
					  </div>
					  <div className="column">
						{next}
					  </div>
					</div>
        		</div>
        	</>
		}
		</ContextConsumer>
    )
}

export default PortfolioTemplate

export const query = graphql`
  query PortfolioTemplate($slug: String!) {
    allRestApiWork(filter: { slug: {eq: $slug} }) {
      edges {
        node {
            active
            title
            slug
            link
	        blurb
	        date
	        body_colour
            text_colour
            header_text_colour
            hero_align
            worksection_set {
                pk
                text
                layout
                align
                align_vertical
                wide
                full
                sorting
                worksectionimage_set {
                    pk
                    title
                    sorting
		            rounded
		            shadow
                    image
                    localImage {
                        ext
                        publicURL
                        childImageSharp {
                            fluid(maxWidth: 1360, quality: 100) {
								...GatsbyImageSharpFluid_tracedSVG
                                src
                            }
							thumb: fluid(maxWidth: 270, maxHeight: 270) {
							  ...GatsbyImageSharpFluid
							}
							full: fluid(maxWidth: 1360) {
							  ...GatsbyImageSharpFluid
							}
                        }
                    }
                }
            }
            localImage {
                childImageSharp {
                    fluid(maxWidth: 1360) {
						...GatsbyImageSharpFluid_tracedSVG
                    }
                }
            }
            localHeaderImage {
                childImageSharp {
                    fluid(maxWidth: 1360) {
						...GatsbyImageSharpFluid_tracedSVG
                    }
                }
            }
            localHeroImage {
                childImageSharp {
                    fluid(maxWidth: 1360) {
						...GatsbyImageSharpFluid_tracedSVG
                    }
                }
            }
        }
     }
  }
}
`
